import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {MdClose} from 'react-icons/md'
import SideModal from './SideModal'

export const SideModalLayout = ({
                                  title = null,
                                  closeText = 'close',
                                  renderHeader,
                                  onCancel,
                                  children,
                                  headerStyle,
                                  bodyStyle = {}
                                }) => {
  const translate = useTranslate()
  return (
    <>
      {renderHeader ? (
        renderHeader(onCancel)
      ) : (
        <>
          <div
            className="flex  items-center w-full px-4  background  flex-shrink-0 sticky z-20 top-0 "
            style={{
              minHeight: 'var(--header-height)',
              ...(headerStyle ?? {}),
            }}>
              <div className="font-bold text-color-000 flex-1 truncate">{title}</div>
              <MdClose onClick={onCancel} className="text-color-400 hover:text-color-100 cursor-pointer"/>
          </div>
          <div
            style={{
              position: 'sticky',
              top: 'var(--header-visible-height)',
            }}
            className="bg-gray-300"
          />
        </>
      )}
      <div className="flex flex-col flex-1" style={bodyStyle}>
        {_.isFunction(children) ? children(onCancel) : children}
      </div>
    </>
  )
}
export const FullSideModalLayout = ({
                                      title = null,
                                      closeText = 'close',
                                      renderHeader,
                                      onCancel,
                                      children,
                                      headerStyle,
                                      bodyStyle = {},
                                      ...props
                                    }) => (
  <SideModal
    onCancel={onCancel}
    {...props}>
    {({close, handleCancel}) => (
      <SideModalLayout
        {...{
          close,
          bodyStyle,
          headerStyle,
          renderHeader,
          onCancel: handleCancel,
        }}
        closeText={closeText}
        title={title}>
        {children}
      </SideModalLayout>
    )}
  </SideModal>
)
